import api from './axios';

export async function uploadPostMedia(file, type = 'inline', postId = 'temp', onProgress) {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('type', type);
  formData.append('postId', postId);
  const { data } = await api.post('/posts/upload-image', formData, {
    onUploadProgress: onProgress ? (e) => {
      const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
      onProgress(percent);
    } : undefined,
  });
  return data;
}

/** @deprecated Use uploadPostMedia */
export const uploadPostImage = uploadPostMedia;
